<template>
  <div class="invoice-manage-container">
    <el-container>
      <el-main>
        <div class="header">
          <h1>发票管理</h1>
        </div>

        <!-- 搜索和筛选区域 -->
        <div class="filter-section">
          <el-form :inline="true" :model="filterForm" class="filter-form">
            <el-form-item label="时间范围">
              <el-date-picker
                v-model="filterForm.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="YYYY-MM-DD"
                @change="handleFilter"
              />
            </el-form-item>
            <el-form-item label="发票状态">
              <el-select
                v-model="filterForm.status"
                placeholder="选择状态"
                clearable
                @change="handleFilter"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="发票类型">
              <el-select
                v-model="filterForm.type"
                placeholder="选择类型"
                clearable
                @change="handleFilter"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleFilter">查询</el-button>
              <el-button @click="resetFilter">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 发票列表 -->
        <div class="invoice-list">
          <el-table
            :data="filteredInvoices"
            style="width: 100%"
            border
            v-loading="loading"
          >
            <el-table-column prop="id" label="发票编号" width="90" />

            <el-table-column prop="invoice_type" label="发票类型" width="90">
              <template #default="scope">
                {{ scope.row.invoice_type === "personal" ? "个人" : "企业" }}
              </template>
            </el-table-column>
            <el-table-column prop="title" label="发票抬头" min-width="180" />
            <el-table-column prop="amount" label="金额" width="120">
              <template #default="scope">
                ¥{{ scope.row.amount.toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template #default="scope">
                <el-tag :type="getStatusType(scope.row.status)">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="user_name" label="申请人" width="80" />
            <el-table-column prop="create_time" label="申请时间" width="180" />
            <el-table-column label="操作" width="140" fixed="right">
              <template #default="scope">
                <el-button
                  v-if="scope.row.status === 1"
                  type="success"
                  size="small"
                  @click="handleComplete(scope.row)"
                >
                  开具
                </el-button>
                <el-button
                  v-if="scope.row.status === 2"
                  type="primary"
                  size="small"
                  @click="handleDownload(scope.row)"
                >
                  下载
                </el-button>
                <el-button
                  style="margin-left: 10px"
                  type="info"
                  size="small"
                  @click="exportInvoiceReceipt(scope.row)"
                >
                  导出
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";

const API_BASE_URL = "https://www.xiaoliangtongxue.cn/api";

export default {
  name: "InvoiceManage",
  data() {
    return {
      loading: false,
      invoices: [],
      filterForm: {
        dateRange: [],
        status: "",
        type: "",
      },
      statusOptions: [
        { label: "已申请", value: 1 },
        { label: "已开具", value: 2 },
      ],
      typeOptions: [
        { label: "个人", value: "personal" },
        { label: "企业", value: "company" },
      ],
    };
  },
  computed: {
    filteredInvoices() {
      let result = [...this.invoices];

      // 日期筛选
      if (this.filterForm.dateRange && this.filterForm.dateRange.length === 2) {
        const [startDate, endDate] = this.filterForm.dateRange;
        result = result.filter((invoice) => {
          const invoiceDate = invoice.create_time.split(" ")[0];
          return invoiceDate >= startDate && invoiceDate <= endDate;
        });
      }

      // 状态筛选
      if (this.filterForm.status !== "") {
        result = result.filter(
          (invoice) => invoice.status === this.filterForm.status
        );
      }

      // 类型筛选
      if (this.filterForm.type) {
        result = result.filter(
          (invoice) => invoice.invoice_type === this.filterForm.type
        );
      }

      return result;
    },
  },
  created() {
    this.fetchInvoices();
  },
  methods: {
    async exportInvoiceReceipt(invoice) {
      try {
        // 生成发票回执内容
        const content = [
          "========= 发票回执 =========",
          `发票编号: ${invoice.id}`,
          `申请人: ${invoice.user_name}`,
          `申请时间: ${invoice.create_time}`,
          `发票类型: ${invoice.invoice_type === "personal" ? "个人" : "企业"}`,
          `发票抬头: ${invoice.title}`,
          `税号: ${invoice.tax_number || "-"}`,
          `金额: ¥${invoice.amount.toFixed(2)}`,
          `接收邮箱: ${invoice.email}`,
          `状态: ${this.getStatusText(invoice.status)}`,
          `打印时间: ${new Date().toLocaleString()}`,
          "=============================",
        ].join("\n");

        // 创建Blob对象
        const blob = new Blob([content], { type: "text/plain;charset=utf-8" });

        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `发票回执_${invoice.id}.txt`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        this.$message.success("发票回执导出成功");
      } catch (error) {
        console.error("导出发票回执失败:", error);
        this.$message.error("导出发票回执失败，请稍后重试");
      }
    },
    async fetchInvoices() {
      try {
        this.loading = true;
        const response = await axios.get(`${API_BASE_URL}/invoice`);
        this.invoices = response.data;
        console.log(this.invoices);
      } catch (error) {
        console.error("获取发票列表失败:", error);
        this.$message.error("获取发票列表失败");
      } finally {
        this.loading = false;
      }
    },
    getStatusType(status) {
      const statusMap = {
        0: "info", // 未开具
        1: "warning", // 已申请
        2: "success", // 已开具
      };
      return statusMap[status] || "info";
    },
    getStatusText(status) {
      const statusMap = {
        0: "未开具",
        1: "已申请",
        2: "已开具",
      };
      return statusMap[status] || "未知";
    },
    getOrderStatusType(status) {
      const statusMap = {
        unpaid: "danger",
        printing: "warning",
        delivering: "primary",
        completed: "success",
        cancelled: "info",
      };
      return statusMap[status] || "info";
    },
    handleFilter() {
      // 筛选已在计算属性中处理
    },
    resetFilter() {
      this.filterForm = {
        dateRange: [],
        status: "",
        type: "",
      };
    },

    async handleComplete(invoice) {
      try {
        // 创建文件输入元素
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = ".pdf";
        fileInput.style.display = "none";

        // 监听文件选择
        fileInput.onchange = async (event) => {
          const file = event.target.files[0];
          if (!file) {
            return;
          }

          // 检查文件类型
          if (file.type !== "application/pdf") {
            this.$message.error("请选择PDF文件");
            return;
          }

          // 检查文件大小（64MB限制）
          if (file.size > 64 * 1024 * 1024) {
            this.$message.error("文件大小不能超过64MB");
            return;
          }

          // 显示确认对话框
          try {
            await this.$confirm(
              `确认要上传文件 "${file.name}" 并为发票 ${invoice.id} 开具吗？`,
              "确认开具",
              {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
              }
            );

            // 用户确认后，开始上传
            try {
              // 创建FormData
              const formData = new FormData();
              formData.append("file", file);
              formData.append("invoice_id", invoice.id);

              // 显示上传进度
              this.$message.info("正在上传发票文件...");

              // 上传文件
              const uploadResponse = await axios.post(
                `${API_BASE_URL}/upload-invoice-file`,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                }
              );

              if (uploadResponse.data.success) {
                // 更新发票状态为已开具
                const statusResponse = await axios.put(
                  `${API_BASE_URL}/invoice/${invoice.id}/status`,
                  { status: 2 }
                );

                if (statusResponse.data.success) {
                  this.$message.success("发票已开具并上传文件成功");
                  await this.fetchInvoices();
                } else {
                  this.$message.error(
                    statusResponse.data.message || "更新发票状态失败"
                  );
                }
              } else {
                this.$message.error(
                  uploadResponse.data.message || "文件上传失败"
                );
              }
            } catch (error) {
              console.error("开具发票失败:", error);
              this.$message.error("开具发票失败，请稍后重试");
            }
          } catch (confirmError) {
            // 用户取消操作
            this.$message.info("已取消开具操作");
          }
        };

        // 触发文件选择
        document.body.appendChild(fileInput);
        fileInput.click();
        document.body.removeChild(fileInput);
      } catch (error) {
        console.error("开具发票失败:", error);
        this.$message.error("开具发票失败");
      }
    },

    async handleDownload(invoice) {
      try {
        // 直接打开下载链接
        window.open(`${API_BASE_URL}/download-invoice-file/${invoice.id}`);
        this.$message.success("发票下载已开始");
      } catch (error) {
        console.error("下载发票失败:", error);
        this.$message.error("下载发票失败");
      }
    },
  },
};
</script>

<style scoped>
.invoice-manage-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.header {
  text-align: center;
  margin-bottom: 30px;
  position: relative;
  padding-bottom: 16px;
}

.header h1 {
  color: #000000;
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 1px;
}

.filter-section {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-left: 40px;
}

.invoice-list {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
}

:deep(.el-descriptions) {
  margin-bottom: 20px;
}

:deep(.el-descriptions__cell) {
  padding: 12px 20px;
}

.el-main {
  display: flex;
  flex-direction: column;
}

:deep(.el-table) {
  overflow: hidden;
  --el-table-border-color: #000000;
  --el-table-header-bg-color: #ffffff;
}

:deep(.el-table--border::after),
:deep(.el-table--group::after),
:deep(.el-table::before) {
  background-color: #000000;
}

:deep(.el-table__inner-wrapper::before) {
  background-color: #000000;
}

:deep(.el-table__header th) {
  background-color: var(--el-table-header-bg-color);
  color: #000000;
  font-weight: 600;
  height: 50px;
  padding: 8px 0;
  text-align: center;
}

:deep(.el-table__body td) {
  padding: 12px 0;
  color: #333333;
  text-align: center;
}

:deep(.el-table__body tr:hover > td) {
  background-color: #f5f5f5 !important;
}

:deep(.el-table__body-wrapper) {
  overflow-x: auto !important;
}

:deep(.el-tag) {
  border-radius: 4px;
  padding: 4px 12px;
  font-weight: 500;
  border: 1px solid #000000;
  background-color: #ffffff;
  color: #000000;
}

:deep(.el-tag--warning) {
  background-color: #ffffff;
  color: #000000;
  border-color: #000000;
}

:deep(.el-tag--primary) {
  background-color: #ffffff;
  color: #000000;
  border-color: #000000;
}

:deep(.el-tag--info) {
  background-color: #ffffff;
  color: #000000;
  border-color: #000000;
}

:deep(.el-tag--success) {
  background-color: #ffffff;
  color: #000000;
  border-color: #000000;
}

:deep(.el-tag--danger) {
  background-color: #ffffff;
  color: #000000;
  border-color: #000000;
}

:deep(.el-button--primary) {
  background-color: #000000;
  border-color: #000000;
  color: #ffffff;
}

:deep(.el-button--primary:hover) {
  background-color: #333333;
  border-color: #333333;
}

:deep(.el-button--default) {
  background-color: #ffffff;
  border: 1px solid #000000;
  color: #000000;
}

:deep(.el-button--default:hover) {
  background-color: #000000;
  color: #ffffff;
}

:deep(.el-button--success) {
  background-color: #000000;
  border-color: #000000;
  color: #ffffff;
}

:deep(.el-button--success:hover) {
  background-color: #333333;
  border-color: #333333;
}

:deep(.el-button--info) {
  background-color: #ffffff;
  border: 1px solid #000000;
  color: #000000;
}

:deep(.el-button--info:hover) {
  background-color: #000000;
  color: #ffffff;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background-color: #000000;
  border-color: #000000;
}

:deep(.el-checkbox__inner:hover) {
  border-color: #000000;
}

:deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #000000;
}

:deep(.el-radio__input.is-checked .el-radio__inner) {
  border-color: #000000;
  background-color: #000000;
}

:deep(.el-radio__inner:hover) {
  border-color: #000000;
}

:deep(.el-radio__input.is-checked + .el-radio__label) {
  color: #000000;
}

:deep(.el-radio__inner::after) {
  background-color: #ffffff;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .invoice-manage-container {
    padding: 10px;
  }

  .filter-form {
    flex-direction: column;
  }

  :deep(.el-form-item) {
    margin-right: 0;
  }
}
</style> 